import React, { useState, useRef, useEffect } from "react";
import toast from "react-hot-toast";

export default function FriendPersonalInfoPage ({ data, homedata, relations = [], onUpdateRelations, friendName = '' }) {
  const [openBasic, setOpenBasic] = useState(true);
  const [openAddress, setOpenAddress] = useState(false);
  const [isAddressCopied, setIsAddressCopied] = useState(false);
  const copyResetTimeoutRef = useRef(null);
  const [copyMessage, setCopyMessage] = useState("");

  // Relationship tags management
  const [tagOptionsList, setTagOptionsList] = useState(["Family", "Friend", "Work", "Other"]);
  const [localRelations, setLocalRelations] = useState(Array.isArray(relations) ? relations.slice() : []);
  useEffect(() => {
    setLocalRelations(Array.isArray(relations) ? relations.slice() : []);
  }, [relations]);

  const handleUpdateRelations = (newRelations) => {
    setLocalRelations(newRelations);
    if (onUpdateRelations) onUpdateRelations(newRelations);
  };

  const tagIcon = (tag) => {
    switch ((tag || '').toLowerCase()) {
      case 'family':
        return (
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 11c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 11c1.66 0 3-1.34 3-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2 20c0-2.5 4-4.5 10-4.5s10 2 10 4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 'friend':
        // Use a single-person silhouette for 'friend' so it differs from 'family'
        return (
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5 20c0-3 3.5-5 7-5s7 2 7 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        );
      case 'work':
        return (
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="7" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="2"/>
            <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 'other':
        return (
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
            <path d="M12 8v5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <circle cx="12" cy="16.5" r="0.5" fill="currentColor" />
          </svg>
        );
      default:
        return (
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
    }
  };

  // Add Tag removed per design request; tag list is fixed for now

  const fieldConfig = [
    { key: 'first_name', label: 'First Name', section: 'basic', icon: '../input-logos/user.svg' },
    { key: 'last_name', label: 'Last Name', section: 'basic', icon: '../input-logos/user.svg' },
    { key: 'personal_email_id', label: 'Personal Email Id', section: 'basic', icon: '../input-logos/sms.svg' },
    { key: 'work_email_id', label: 'Work Email Id', section: 'basic', icon: '../input-logos/sms.svg' },
    { key: 'secondary_email', label: 'Secondary Email', section: 'basic', icon: '../input-logos/sms.svg' },
    { key: 'personal_mobile', label: 'Personal Mobile', section: 'basic', icon: '../input-logos/call.svg' },
    { key: 'work_mobile', label: 'Work Mobile', section: 'basic', icon: '../input-logos/call.svg' },
    { key: 'secondary_mobile', label: 'Secondary Mobile', section: 'basic', icon: '../input-logos/call.svg' },
    { key: 'home_fixed', label: 'Home Fixed', section: 'basic', icon: '../input-logos/call.svg' },
    { key: 'work_fixed', label: 'Work Fixed', section: 'basic', icon: '../input-logos/call.svg' },
    { key: 'date_of_birth_DD_MM', label: 'Date of Birth (DD/MM)', section: 'basic', icon: '../input-logos/calander.svg' },
    {key: "date_of_birth_YYYY", label: "Date of Birth (YYYY)", section: "basic", icon: '../input-logos/calander.svg'},
    { key: 'marital_status', label: 'Marital Status', section: 'basic', icon: '../input-logos/ring.svg' },
    { key: 'date_of_anniversary', label: 'Anniversary Date', section: 'basic', icon: '../input-logos/calander.svg' },
    { key: 'birth_city_country', label: 'Birth City and Country', section: 'basic', icon: '../input-logos/location.svg' },
    { key: 'basic_pincode_home', label: 'Pincode - Home', section: 'basic', icon: '../input-logos/location.svg' },
    { key: 'current_city_region_country', label: 'Current City, Region and Country', section: 'basic', icon: '../input-logos/location.svg' },

    { key: 'flat_number', label: 'Flat Number / House Number', section: 'address', icon: '../input-logos/building.svg' },
    { key: 'building_name', label: 'Building Name / House Name', section: 'address', icon: '../input-logos/building.svg' },
    { key: 'street_name', label: 'Street Name', section: 'address' },
    { key: 'city_region_country', label: 'City, Region and Country', section: 'address' },
    { key: 'address_google_map', label: 'Address', section: 'address', icon: '../input-logos/location.svg' },
  ];

  // Return an inline SVG icon JSX for a given field key
  const iconForKey = (key) => {
    switch (key) {
      case 'first_name':
      case 'last_name':
        return (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z" stroke="#6938EF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M4 20c0-2.67 4-4 8-4s8 1.33 8 4" stroke="#6938EF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 'personal_email_id':
      case 'work_email_id':
      case 'secondary_email':
        return (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 8l9 6 9-6" stroke="#6938EF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <rect x="3" y="5" width="18" height="14" rx="2" stroke="#6938EF" strokeWidth="1.2"/>
          </svg>
        );
      case 'personal_mobile':
      case 'work_mobile':
      case 'secondary_mobile':
      case 'home_fixed':
      case 'work_fixed':
        return (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 16.92V20a2 2 0 0 1-2.18 2A19.86 19.86 0 0 1 3 5.18 2 2 0 0 1 5 3h3.09a1 1 0 0 1 1 .75c.12.74.37 1.45.73 2.09a1 1 0 0 1-.25 1.09L8.91 9.91" stroke="#6938EF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 'date_of_birth_DD_MM':
      case 'date_of_birth_YYYY':
      case 'date_of_anniversary':
        return (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="4" width="18" height="18" rx="2" stroke="#6938EF" strokeWidth="1.2"/>
            <path d="M16 2v4M8 2v4M3 10h18" stroke="#6938EF" strokeWidth="1.2" strokeLinecap="round"/>
          </svg>
        );
      case 'marital_status':
        return (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.8 4.6a5 5 0 0 0-7.1 0L12 6.3l-1.7-1.7a5 5 0 0 0-7.1 7.1L12 21.2l8.8-9.5a5 5 0 0 0 0-7.1z" stroke="#6938EF" strokeWidth="1" fill="none"/>
          </svg>
        );
      case 'birth_city_country':
      case 'current_city_region_country':
      case 'city_region_country':
        return (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C8 2 4 5.5 4 10c0 6 8 12 8 12s8-6 8-12c0-4.5-4-8-8-8z" stroke="#6938EF" strokeWidth="1.2" fill="none"/>
            <circle cx="12" cy="10" r="2" stroke="#6938EF" strokeWidth="1.2" fill="none"/>
          </svg>
        );
      case 'basic_pincode_home':
      case 'flat_number':
      case 'building_name':
      case 'street_name':
        return (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="#6938EF" strokeWidth="1.2"/>
            <path d="M7 7h10M7 12h10M7 17h6" stroke="#6938EF" strokeWidth="1" strokeLinecap="round"/>
          </svg>
        );
      case 'address_google_map':
        return (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 10c0 6-9 12-9 12S3 16 3 10a9 9 0 1 1 18 0z" stroke="#6938EF" strokeWidth="1.2" fill="none"/>
            <circle cx="12" cy="10" r="2" stroke="#6938EF" strokeWidth="1.2" fill="none"/>
          </svg>
        );
      default:
        return (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 12h18" stroke="#6938EF" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        );
    }
  };

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (copyResetTimeoutRef.current) {
        clearTimeout(copyResetTimeoutRef.current);
      }
    };
  }, []);

  const handleCopyAddress = async (addressText) => {
    const text = String(addressText || "").trim();
    if (!text) {
      toast.error("No address to copy");
      return;
    }

    const showCopiedState = () => {
      setIsAddressCopied(true);
      if (copyResetTimeoutRef.current) clearTimeout(copyResetTimeoutRef.current);
      copyResetTimeoutRef.current = setTimeout(() => {
        setIsAddressCopied(false);
      }, 1500);
    };

    try {
      await navigator.clipboard.writeText(text);
      toast.success("Address copied");
      showCopiedState();
    } catch {
      const tempTextArea = document.createElement("textarea");
      tempTextArea.value = text;
      document.body.appendChild(tempTextArea);
      tempTextArea.select();
      document.execCommand("copy");
      document.body.removeChild(tempTextArea);
      toast.success("Address copied");
      showCopiedState();
    }
  };
  

  const getFieldValueByKey = (key) => {
    const phoneKeyMap = {
      personal_mobile: 'country_code_personal',
      work_mobile: 'country_code_alternative_work_num',
      secondary_mobile: 'country_code_home',
      home_fixed: 'country_code_home_fixed',
      work_fixed: 'country_code_work_fixed',
    };

    const homeAddress = Array.isArray(homedata)
      ? homedata?.[0]?.home || homedata?.[0] || {}
      : homedata?.home || homedata || {};

    const addressKeyMap = {
      flat_number: homeAddress?.flat_number,
      building_name: homeAddress?.building_name,
      street_name: homeAddress?.street_name,
      city_region_country: homeAddress?.city_region_country,
      address_google_map: homeAddress?.google_map_link || homeAddress?.address_google_map,
    };

    const value = Object.prototype.hasOwnProperty.call(addressKeyMap, key)
      ? addressKeyMap[key]
      : formData?.[key];

    if (value === undefined || value === null) return '';
    const trimmed = String(value).trim();
    if (!trimmed) return '';

    // For phone fields, include a country code if available
    if (Object.prototype.hasOwnProperty.call(phoneKeyMap, key)) {
      const codeField = phoneKeyMap[key];
      const code = formData?.[codeField] || formData?.country_code || "+91";
      return `${code} ${trimmed}`;
    }

    return trimmed;
  };

  // Filter data - handle both array and object formats, and avoid undefined
  const formData = (data && typeof data === 'object' && !Array.isArray(data)) ? data : (Array.isArray(data) && data[0] ? data[0] : {});

  const sortedData = fieldConfig
    .map((field) => ({
      ...field,
      value: getFieldValueByKey(field.key),
    }))
    .filter((field) => String(field.value || '').trim() !== '');

  const basicData = sortedData.filter((field) => field.section === 'basic');
  const addressData = sortedData.filter((field) => field.section === 'address');

  // Tag handlers
  const handleTagClick = (tag) => {
    setLocalRelations((prev) => {
      const normalizedTag = String(tag || "").toLowerCase();
      const isOtherTag = normalizedTag === "other";
      let nextRelations = [];

      if (isOtherTag) {
        // "Other" is exclusive: selecting it removes all other tags.
        const alreadyOnlyOther = prev.length === 1 && prev.some((t) => String(t || "").toLowerCase() === "other");
        nextRelations = alreadyOnlyOther ? [] : [tag];
      } else {
        const withoutOther = prev.filter((t) => String(t || "").toLowerCase() !== "other");
        const exists = withoutOther.includes(tag);
        nextRelations = exists ? withoutOther.filter((t) => t !== tag) : [...withoutOther, tag];
      }

      handleUpdateRelations(nextRelations);
      return nextRelations;
    });
  };

  const hasBasicData = basicData.length > 0;
  const hasAddressData = addressData.length > 0;

  // (removed textarea auto-resize — address now rendered as display rows)

  return (
    <div>
      <div className="rounded-2xl p-4 min-[900px]:p-6 ">
        {/* Relationship / Tags */}
        <div className="hidden min-[900px]:flex w-full mb-4">
          <div className="bg-white rounded-2xl border border-gray-100 p-4 shadow-sm w-full">
            <div className="flex justify-between items-start mb-3">
              <div>
                <h3 className="text-xs font-semibold text-[#6366F1] uppercase tracking-wide">Relationship</h3>
                <div className="text-sm text-gray-600">How you know {friendName || 'this person'}</div>
              </div>
            </div>

            <div className="mt-1 grid w-full grid-cols-2 gap-3 sm:grid-cols-4">
              {tagOptionsList.map((tag) => {
                const active = localRelations.includes(tag);
                return (
                  <button
                    key={tag}
                    type="button"
                    onClick={() => handleTagClick(tag)}
                    aria-pressed={active}
                    className={`flex w-full items-center justify-center gap-2 rounded-xl px-3 py-2.5 text-sm font-medium transition ${active ? "bg-[#6C45FF] text-white shadow-md" : "border border-gray-400 bg-white text-gray-800"}`}
                  >
                    <span className={`h-4 w-4 shrink-0 ${active ? "text-white" : "text-gray-500"}`}>
                      {tagIcon(tag)}
                    </span>
                    <span className="truncate">{tag}</span>
                  </button>
                );
              })}
            </div>

            <div className="text-xs text-gray-400 mt-3">You can select multiple tags (except Other)</div>
          </div>
        </div>
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg font-semibold text-gray-900">Personal Info</h2>
        </div>

        <div className="space-y-3">
          {/* Section 1: Basic Details */}
          {hasBasicData && (
            <div className="border border-gray-100 rounded-xl bg-white">
              <button
                type="button"
                onClick={() => setOpenBasic(!openBasic)}
                className={`sticky top-0 z-30 w-full flex items-center justify-between px-5 py-4 transition-all bg-white ${
                  openBasic
                    ? "bg-gradient-to-r from-[#6938EF]/5 to-transparent border-b border-[#E6E2FF]"
                    : "bg-gradient-to-r from-gray-50 to-white hover:bg-gray-50"
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className={`p-2 rounded-lg transition-colors ${
                    openBasic ? "bg-[#6938EF]/10" : "bg-gray-100"
                  }`}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="8" r="4" stroke={openBasic ? "#6938EF" : "#6B7280"} strokeWidth="2"/>
                      <path d="M6 20c0-2.21 2.686-4 6-4s6 1.79 6 4" stroke={openBasic ? "#6938EF" : "#6B7280"} strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  </div>
                  <span className={`font-semibold transition-colors ${
                    openBasic ? "text-[#6938EF]" : "text-gray-900"
                  }`}>Contact & Personal Details</span>
                </div>
                <span className={`transition-transform duration-300 ${
                  openBasic ? "rotate-180 text-[#6938EF]" : "text-gray-400"
                }`}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </button>
              {openBasic && (
                <div className="grid grid-cols-1 min-[1150px]:grid-cols-2 gap-0 px-4 pb-4">
                  {/** Render fields in two-column display rows matching screenshot */}
                  {basicData.map((field) => (
                    <div key={field.key} className="flex items-center gap-3 px-4 py-4 border-b last:border-b-0">
                      <div className="w-8 h-8 flex items-center justify-center rounded-md bg-gray-50 text-[#6938EF]">
                        {/** simple icon based on key */}
                        {field.icon ? (
                          <img src={field.icon} alt="" className="w-4 h-4" />
                        ) : (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 12h18" stroke="#6938EF" strokeWidth="1.5" strokeLinecap="round"/>
                          </svg>
                        )}
                      </div>
                      <div className="flex-1 min-w-0 space-y-1">
                        <div className="text-xs text-gray-500">{field.label.replace(/Id$/,'')}</div>
                        <div className="text-sm font-medium text-gray-900 break-words">{field.value || '—'}</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Section 2: Address & Location */}
          {hasAddressData && (
            <div className="border border-gray-100 rounded-xl bg-white">
              <button
                type="button"
                onClick={() => setOpenAddress(!openAddress)}
                className={`sticky top-0 z-30 w-full flex items-center justify-between px-5 py-4 transition-all bg-white ${
                  openAddress
                    ? "bg-gradient-to-r from-[#6938EF]/5 to-transparent border-b border-[#E6E2FF]"
                    : "bg-gradient-to-r from-gray-50 to-white hover:bg-gray-50"
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className={`p-2 rounded-lg transition-colors ${
                    openAddress ? "bg-[#6938EF]/10" : "bg-gray-100"
                  }`}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C7.58 2 4 5.58 4 10c0 5.25 8 13 8 13s8-7.75 8-13c0-4.42-3.58-8-8-8zm0 11c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" fill={openAddress ? "#6938EF" : "#6B7280"}/>
                    </svg>
                  </div>
                  <span className={`font-semibold transition-colors ${
                    openAddress ? "text-[#6938EF]" : "text-gray-900"
                  }`}>Address & Location</span>
                </div>
                <span className={`transition-transform duration-300 ${
                  openAddress ? "rotate-180 text-[#6938EF]" : "text-gray-400"
                }`}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </button>
              {openAddress && (
                <div className="grid grid-cols-1 min-[1150px]:grid-cols-2 gap-4 px-4 pb-4">
                  {addressData.map((field) => {
                    // Special handling for address field with copy button and auto-height
                    if (field.key === 'address_google_map') {
                      return (
                        <div key={field.key} className="min-[1150px]:col-span-2 px-4 py-4 border-b last:border-b-0">
                          <div className="flex items-start gap-3">
                            <div className="w-8 h-8 flex items-center justify-center rounded-md bg-gray-50 text-[#6938EF]">
                              {field.icon ? (
                                <img src={field.icon} alt="" className="w-4 h-4" />
                              ) : iconForKey(field.key)}
                            </div>
                            <div className="flex-1">
                              <div className="flex items-center justify-between">
                                <div>
                                  <div className="text-xs text-gray-500">{field.label}</div>
                                  <div className="text-sm font-medium text-gray-900 break-words">{field.value || '—'}</div>
                                </div>
                                {String(field.value || "").trim() && (
                                  <button
                                    type="button"
                                    onClick={() => handleCopyAddress(field.value)}
                                    className="text-xs font-medium text-[#6938EF] hover:text-[#5a2fd6]"
                                  >
                                    {isAddressCopied ? "Copied!" : "Copy"}
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }

                    // Standard display rendering for address fields
                    return (
                      <div key={field.key} className="flex items-center gap-3 px-4 py-4 border-b last:border-b-0">
                        <div className="w-8 h-8 flex items-center justify-center rounded-md bg-gray-50 text-[#6938EF]">
                          {field.icon ? (
                            <img src={field.icon} alt="" className="w-4 h-4" />
                          ) : (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M3 12h18" stroke="#6938EF" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
                          )}
                        </div>
                        <div className="flex-1">
                          <div className="text-xs text-gray-500">{field.label}</div>
                          <div className="text-sm font-medium text-gray-900">{field.value || '—'}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {!hasBasicData && !hasAddressData && (
              <div className="flex flex-col h-[70dvh] justify-center items-center">
                <img src="../no-data/no-personal.svg" alt="No data" className="mx-auto mb-4 h-40 w-40" />
                <p className="font-semibold text-[28px]">No Personal Info added yet.</p>
              <p className="text-gray-500 text-center">This user hasn’t added Personal Information yet.</p>
              </div>
          )}
        </div>
      </div>
    </div>
  );
}
